import { useStaticQuery, graphql } from "gatsby";

const useSiteData = () => {
  const {
    site: { siteMetadata: siteDataOriginal },
  } = useQuery();

  return siteDataOriginal;
};

export default useSiteData;

const useQuery = () =>
  useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          ds11_svg
          ds82_svg
          ds64_svg
          passport_small_svg
        }
      }
    }
  `);
